import React, { useEffect, useRef, useState } from "react";
import {
  CALL_ICON,
  CANCEL_ICON,
  CANCELHIDE_ICON,
  CHATE_ICON,
  DOCTOR_DETAIL_IAMGE,
  LOCATIONSHARE_ICON,
  PRESCRIPTION,
  PRESCRIPTIONLIGHT,
  PROFILE_IMG,
  VIDEO_ICON,
} from "../../utils/aap-image-constant";
import TableLayout from "../../components/layouts/table-layout";
import TableHeading from "../../components/common/TableHeading";
import Modal from "../../components/common/Model";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import { appointmentList, getQuestionAnswer } from "../../hooks/services/api-services";
import { decryptAEStoJSON, toastEmitter } from "../../utils/utilities";
import { useSelector } from "react-redux";
import { convertAppointmentTimeToAMPM, fileDownload } from "../../utils/form-utils";
import AccessPermissionpage from "../../components/common/accessPermissionpage";
import { API_URL } from "../../utils/url-constants";
import Input from "../../components/common/input";
import TextArea from "../../components/common/text-area";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import BreadCrum from "../../components/common/BreadCrum";
const PatientAppointmentsDetail = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const patientId = location?.state?.patientId;
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [reasonData, setReasonData] = useState("");
  const reasonModalRef = useRef(null);
  const ViewApointmentmodal = useRef();
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const [rowData, setRowData] = useState([]);
  const [questionData, setQuestonData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const tableColumns = [
    {
      name: t("S.No"),
      width: "70px",
      selector: (row, i) => i + 1,
    },

    {
      name: t("Patient Name"),
      selector: (row) => row?.patientResponse?.fullName,
      sortable: true,
      code: "full_name",
      minWidth: "140px",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fw-600 fs-12">
          <div
            className="rounded-circle overflow-hidden rounded-circle"
          >
            <img
              src={row?.patientResponse?.image ? `${API_URL?.ServerURL}${row?.patientResponse?.image}` : PROFILE_IMG}
              alt=""
              style={{
                objectFit: "cover", objectPosition: "center", width: "32px",
                height: "32px",
              }}
            />
          </div>
          {row?.patientResponse?.fullName}
        </div>
      ),
    },
    {
      name: t("Doctor Name"),
      sortable: true,
      minWidth: "180px",
      code: "first_name",
      selector: (row) => row?.doctorResponse?.firstName,
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center">
          <div
            className="rounded-circle overflow-hidden rounded-circle"
          >
            <img
              src={row?.doctorResponse?.image ? `${API_URL?.ServerURL}${row?.doctorResponse?.image}` : PROFILE_IMG}
              alt=""
              style={{
                objectFit: "cover", objectPosition: "center", width: "32px",
                height: "32px",
              }}

            />
          </div>
          {row?.doctorResponse?.firstName} {row?.doctorResponse?.lastName}
        </div>
      ),
    },
    {
      name: t("Status"),
      sortable: true,
      code: "status",
      selector: (row) => row?.status,
      width: "130px",
      cell: (row) => {
        let statusLabel = "";
        let bgColor = "";
        let textColor = "";
        let dotColor = "";
        switch (row.status) {
          case 1:
            statusLabel = "Upcoming";
            bgColor = "bg-orange-normal";
            textColor = "color-orange-bold";
            dotColor = "bg-orange-bold";
            break;
          case 2:
            statusLabel = "Completed";
            bgColor = "bg-green-normal";
            textColor = "color-green-bold";
            dotColor = "bg-green-bold";
            break;
          case 3:
            statusLabel = "Expired";
            bgColor = "bg-gray-normal";
            textColor = "color-gray-bold";
            dotColor = "bg-gray-bold ";
            break;
          case 4:
            statusLabel = "Patient";
            bgColor = "bg-red-normal";
            textColor = "color-red-bold";
            dotColor = "bg-red-bold";
            break;
          case 5:
            statusLabel = "Doctor";
            bgColor = "bg-red-normal";
            textColor = "color-red-bold";
            dotColor = "bg-red-bold";
            break;
          default:
            statusLabel = "Inactive";
            bgColor = "bg-gray-normal";
            textColor = "color-gray-bold";
            dotColor = "bg-gray-bold";
        }
        return (
          <div
            className={`${bgColor} ${textColor} d-flex align-items-center gap-1 px-2 py-1 rounded-4`}
          >
            <div
              className={`rounded-circle ${dotColor}`}
              style={{ width: "10px", height: "10px" }}
            ></div>
            <p className="m-0 fs-12 fw-normal">{statusLabel}</p>
          </div>
        );
      },
    },
    {
      name: t("Date&Time"),
      selector: (row) => (
        <div className="d-flex gap-2 align-items-center">
          {dayjs(row?.appointmentDate)?.format("DD MMM YYYY")}
          <br />
          {convertAppointmentTimeToAMPM(
            row?.appointmentStartingTime,
            row?.appointmentEndingTime
          )}
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: t("Appointment Type"),
      sortable: true,
      code: "appointment_type",
      width: "190px",
      selector: (row) => row?.appointmentType,
      cell: (row) => {
        const mode = row?.appointmentMode?.toLowerCase();
        const type = row?.appointmentType?.toLowerCase();

        const ICON_MAP = {
          online_video: VIDEO_ICON,
          online_voice: CALL_ICON,
          online_chat: CHATE_ICON,
          offline: LOCATIONSHARE_ICON,
        };
        const icon =
          ICON_MAP[type === "offline" ? "offline" : `online_${mode}`] || "";

        return (
          <div className="d-flex gap-2 align-items-center table-cell-content">
            <div>
              <img src={icon} alt="" className="img-fluid" />
            </div>
            <div>
              {row?.appointmentType}
              <br />
              {type === "offline" ? userData?.address : row?.appointmentMode}
            </div>
          </div>
        );
      },
    },
    {
      id: "prescription",
      name: t("Prescription"),
      width: "110px",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center">
          {row?.status === 2 && row?.doctorPrescription ?
            < img
              src={PRESCRIPTION}
              alt=""
              className="img-fluid cursor-pointer"
              onClick={() =>
                fileDownload(
                  `${API_URL?.ServerURL}${row?.doctorPrescription}`
                )
              }
            /> : < img
              src={PRESCRIPTIONLIGHT}
              alt=""
              className="img-fluid"
            />
          }
        </div>
      ),
    },
    {
      id: "reason",
      name: t("Cancel Reason"),
      width: "150px",
      cell: (row) => (
        <button
          className="border-0 bg-white"
          onClick={() => {
            addButtonClickModal(row);
          }}
          disabled={row?.status === 1 || row?.status === 2 || row?.status === 3}
        >
          <img
            src={
              row?.status === 4 || row?.status === 5
                ? CANCEL_ICON
                : CANCELHIDE_ICON
            }
            alt="View"
            className="editicon ms-2"
          />
        </button>
      ),
    },
    {
      id: "detail",
      name: t("Detail"),
      cell: (row) => (
        <button
          className="border-0 bg-white"
          onClick={() => {
            detaileButtonClickModal(row);
          }}
        >
          <img
            src={DOCTOR_DETAIL_IAMGE}
            alt="View"
            className="editicon ms-2"
          />
        </button>
      ),
    },
  ];
  const addButtonClickModal = (data) => {
    setReasonData(data?.reason);
    reasonModalRef?.current?.click();
  };
  const handleStatusSelect = (e) => {
    setSelectedStatus(e.target.value);
  };
  const appointmentStatusOptions = [
    { label: t("Upcoming"), value: 1 },
    { label: t("Completed"), value: 2 },
    { label: t("Cancelled by Doctor"), value: 5 },
    { label: t("Cancelled by Patient"), value: 4 },
    { label: t("Expired"), value: 3 },
  ];
  // get appointment list
  const payload = {
    pageIndex: page || 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    status: selectedStatus,
    searchText: searchTerm,
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    doctorId: 0,
    patientId: patientId,
    clinicId: userData?.id,
    type: "",
    languageType: i18n.language
  };
  const fetchAppointmentLast = async () => {
    setPending(true);
    try {
      const response = await appointmentList(payload);
      if (response?.data?.status !== 200) {
        setRowData([]);
      } else {
        setRowData(response?.data?.data?.myAppointmentResponseList);
        setTotalRows(response?.data?.data?.totalElement);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };
  useEffect(() => {
    fetchAppointmentLast();
  }, [page, pageSize, selectedStatus, searchTerm, sortDirection, sortColumn, i18n.language, patientId]);

  const handleBack = () => {
    navigate(ROUTES.PATIENT);
  };
  // permission code for this module start
  const [permissionAccess, setPermissionAccess] = useState();
  const rawPermission = useSelector((state) => state?.permission?.value);
  const permissions = decryptAEStoJSON(rawPermission);
  useEffect(() => {
    const RoleAccessFilterData =
      permissions &&
      permissions?.filter((v) => v?.moduleName === "Appointment Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, []);
  // permission code for this module end
  const [viewData, setViewData] = useState({});
  const detaileButtonClickModal = (row) => {
    setViewData(row);

    const doctorId = row?.doctorResponse?.id;
    const patientId = row?.patientResponse?.id;
    const languageType = i18n.language;

    // Only call API if valid
    if (doctorId && patientId) {
      getQuestionAnswerData({ doctorId, patientId, languageType });
    } else {
      setQuestonData([]);
    }

    ViewApointmentmodal.current.click();
  };


  // getQuestionAnswer expects numbers, not arrays
  const getQuestionAnswerData = async ({ doctorId, patientId, languageType }) => {
    try {
      const response = await getQuestionAnswer(doctorId, patientId, languageType);
      if (response?.data?.status === 200) {
        const allResponses = response?.data?.data || [];

        const flattenedQuestions = allResponses.flatMap((item) => item.questionOptionResponseList || []);
        setQuestonData(flattenedQuestions);
      } else {
        setQuestonData([]);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };


  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="main_datatable my-lg-3 my-2">
            <BreadCrum
              firstData="Patients"
              iconshow1={true}
              secondData="Patient Appointments "
              onFirstDataClick={handleBack}
            />
            <TableHeading
              showsearchinput={true}
              searchValue={searchTerm}
              setSearchValue={setSearchTerm}
              showbutton={false}
              showDropdown={true}
              options={appointmentStatusOptions}
              handleSelect={handleStatusSelect}
              showastrict={false}
            />
            <div className="table-wrapper">
              <TableLayout
                _tblColumns={tableColumns}
                _rowData={rowData}
                pending={pending}
                pagination={true}
                selectableRows={false}
                setPending={setPending}
                _totalRows={totalRows}
                pageSize={pageSize}
                setPageSize={setPageSize}
                setPage={setPage}
                setSortColumn={setSortColumn}
                setSortDirection={setSortDirection}
              />
            </div>
            <Modal
              modalId="appointmentDetails"
              closebtnclass="closebtnclass"
              modalClick={ViewApointmentmodal}
              modalContentClass="add_doctor card px-3 py-0 border border-radius_input"
              className="modal-lg"
            >
              <div className="">
                <div className="row text-start">
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.patientResponse?.fullName}
                      name="firstName"
                      // placeHolder="Enter Title"
                      labelName="Patient Name"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={`${viewData?.doctorResponse?.firstName || ""} ${viewData?.doctorResponse?.lastName || ""
                        }`}
                      name="firstName"
                      labelName="Doctor Name"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.doctorResponse?.specialization || ""}
                      name="specialty"
                      labelName="Specialization"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.doctorResponse?.email}
                      name="email"
                      labelName="Email"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={`${viewData?.doctorResponse?.code || ""} ${viewData?.doctorResponse?.mobileNo || ""
                        }`}
                      name="mobileNo"
                      labelName="Mobile Number"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.doctorResponse?.country || ""}
                      name="country"
                      labelName="Country"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.doctorResponse?.country || ""}
                      name="country"
                      labelName="Country"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.doctorResponse?.profile || ""}
                      name="profile"
                      labelName="Profile"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.doctorResponse?.address || ""}
                      name="address"
                      labelName="Area / Location of Hospital"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.appointmentFor || ""}
                      name="appointmentFor"
                      labelName={t("Appointment For")}
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.fees || ""}
                      name="fees"
                      labelName={t("Fees")}
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <Input
                      type="text"
                      value={viewData?.doctorResponse?.experience || ""}
                      name="experience"
                      labelName="Experience"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                  {viewData?.doctorResponse?.description && (
                    <div className="col-md-12 mb-2">
                      <TextArea
                        labelName={t("Brief Description")}
                        name="description"
                        value={viewData?.doctorResponse?.description || ""}
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                  )}
                </div>
                <h3 className="fw-600 fs-16 my-2 text-start">{t("Questions Details")}</h3>
                <div className="card p-3 border border-radius_input mb-4 text-start">

                  {questionData?.length > 0 ? (
                    questionData.map((item, index) => (
                      <div key={index} className="mb-3">
                        <div className="mb-2">
                          <label className="fw-500 fs-14">{t("Question")}:</label>
                          <Input
                            type="text"
                            value={item.question}
                            name={`question_${index}`}
                            disabled
                            showAsterisk={false}
                          />
                        </div>
                        <div>
                          <label className="fw-500 fs-14">{t("Answer")}:</label>
                          <Input
                            type="text"
                            value={item.option}
                            name={`option_${index}`}
                            disabled
                            showAsterisk={false}
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>{t("No questions answered")}</p>
                  )}


                </div>


              </div>
            </Modal>
          </div>
          <Modal
            modalId="CancellationReason"
            modalClick={reasonModalRef}
            addButtonClickModal={addButtonClickModal}
            className="modal-sm"
          >
            <div className="text-center py-4">
              <h5 className="fw-bold mb-3 text-danger">
                {t("Cancellation Reason")}
              </h5>
              <p className="text-muted px-3">{reasonData}</p>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default PatientAppointmentsDetail;
